<template>
  <div class="base">
    <inside-header color="#fff" back-link-name="TeacherSetting" title="个人信息" />
    <div class="main">
      <van-form input-align="right" @submit="onSubmit">
        <van-field label="会员身份" value="教员" readonly />
        <van-cell title="头像">
          <a-upload action="/api/index/file/uploadGeneralImage" name="image" :multiple="false" list-type="picture"
            :headers="headers" accept="image/png,image/jpeg" :file-list="headerFileList"
            @change="uploadHeadPortraitHandle">
            <a-button>
              <a-icon type="upload" />修改头像
            </a-button>
          </a-upload>
        </van-cell>
        <van-field v-model="info.nick_name" required name="nick_name" label="昵称" placeholder="请输入昵称"
          :rules="[{ required: true, message: '请输入昵称' }]" />
        <!-- v-model="username" -->
        <van-field v-model="info.sex" required clickable label="性别" name="sex"
          :rules="[{ required: true, message: '请输入昵称' }]" @click="state.gender = true" />
        <van-popup v-model="state.gender" position="bottom">
          <van-picker show-toolbar :columns="['男', '女']" @confirm="onConfirm" @cancel="state.gender = false" />
        </van-popup>
        <div style="weight: 100%;height: 10px;background-color: #eee" />
        <!-- 第二块 -->
        <van-field name="switch" label="接受短信">
          <template #input>
            <van-switch v-model="sms_notice_status" active-color="#ff5c00" size="20" @change="smsNoticeStatusChange" />
          </template>
        </van-field>
        <van-field name="switch" label="接受短信">
          <template #input>
            <van-switch v-model="email_notice_status" active-color="#ff5c00" size="20"
              @change="emailNoticeStatusChange" />
          </template>
        </van-field>
        <van-field name="switch" label="接受短信">
          <template #input>
            <van-switch v-model="wx_notice_status" active-color="#ff5c00" size="20" @change="wxNoticeStatusChange" />
          </template>
        </van-field>
        <van-field name="switch" label="是否展示">
          <template #input>
            <van-switch v-model="display_status" active-color="#ff5c00" size="20" />
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block color="#ff5c00" type="info" :loading="state.submitBtn" native-type="submit">
            保存
          </van-button>
        </div>
      </van-form>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import store from '@/store/'

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      state: {
        gender: false,
        submitBtn: false
      },
      info: {
        nick_name: '',
        sex: ''
      },
      headers: {
        authorization: store.getters.token
      },
      // 头像列表
      headerFileList: [],
      header_img: null,
      headPortrait: [{ url: '/uploads/images/20210113/bac20bea2f3b2ac6183262e044da261a.jpg' }],
      header_resource_id: '',
      profile: {},
      realname: {},
      sms_notice_status: false,
      email_notice_status: false,
      wx_notice_status: false,
      display_status: 'show'
    }
  },
  watch: {
    profile(val) {
      this.info.nick_name = val.nick_name
      this.info.sex = val.sex
      this.sms_notice_status = val.sms_notice_status === 1
      this.email_notice_status = val.email_notice_status === 1
      this.wx_notice_status = val.wx_notice_status === 1
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      // 加载数据
      this.loading = true
      this.$http({
        url: '/index/teacher/profile',
        method: 'get',
        params: {
        }
      }).then(res => {
        this.loading = false
        console.log(res)
        if (res.status === 'success') {
          const data = res.data
          this.profile = data.profile
          this.realname = data.realname
          this.display_status = data.profile.display_status === 'show'
        } else {
          this.$toast.fail('系统繁忙，请刷新重试')
        }
      }).then(() => {
        this.$http({
          url: '/index/index/loadCity',
          method: 'get'
        }).then(res => {
          this.countryDivision = res.data
        })
      })
    },
    uploadHeadPortraitHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$toast.success(`${e.file.name} 文件上传成功`)
          this.header_img = response.data
        } else {
          this.$toast.fail(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      const oneFileList = e.fileList.slice(-1)
      this.headerFileList = oneFileList
      this.header_resource_id = oneFileList[0].response.data.resource_id
    },
    onSubmit(values) {
      this.state.submitBtn = true
      var paramsData = this.info
      paramsData.header_resource_id = this.header_resource_id
      paramsData.display_status = this.display_status ? 'show' : ''
      console.log(paramsData)
      this.$http({
        url: '/index/teacher/profileSave',
        method: 'post',
        data: paramsData
      }).then(res => {
        this.state.submitBtn = false
        if (res.status === 'success') {
          this.$toast.success('保存资料成功')
          const _this = this
          setTimeout(function () {
            _this.$router.push({ name: 'TeacherSetting' })
          }, 2000)
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    onConfirm(value) {
      this.info.sex = value
      this.state.gender = false
    },
    onAreaConfirm(values) {
      this.areaValue = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.showArea = false
    },
    smsNoticeStatusChange(checked) {
      // 修改后台数据
      this.$http({
        url: '/index/teacher/changeSmsNoticeStatus',
        method: 'post',
        data: {
          sms_notice_status: checked
        }
      }).then(res => {
        if (res.status === 'success') {
          this.sms_notice_status = checked
        } else {
          this.$toast.fail('系统繁忙，请刷新重试')
        }
      })
    },
    emailNoticeStatusChange(checked) {
      // 修改后台数据
      this.$http({
        url: '/index/teacher/changeEmailNoticeStatus',
        method: 'post',
        data: {
          email_notice_status: checked
        }
      }).then(res => {
        if (res.status === 'success') {
          this.email_notice_status = checked
        } else {
          this.$toast.fail('系统繁忙，请刷新重试')
        }
      })
    },
    wxNoticeStatusChange(checked) {
      // 修改后台数据
      this.$http({
        url: '/index/teacher/changeWxNoticeStatus',
        method: 'post',
        data: {
          wx_notice_status: checked
        }
      }).then(res => {
        if (res.status === 'success') {
          this.wx_notice_status = checked
        } else {
          this.$toast.fail('系统繁忙，请刷新重试')
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
  }
</style>
